import React from "react";

import FeatureSlider from "../../modules/featureSlider";

const HomePageSlider = ({ blockConfig, slides }) => {
  return <FeatureSlider items={slides} />;
};

export default HomePageSlider;
